import { render, staticRenderFns } from "./AProjects.vue?vue&type=template&id=857ce830&scoped=true"
import script from "./AProjects.vue?vue&type=script&lang=js"
export * from "./AProjects.vue?vue&type=script&lang=js"
import style0 from "./AProjects.vue?vue&type=style&index=0&id=857ce830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857ce830",
  null
  
)

export default component.exports